module.exports = __webpack_public_path__ + "static/media/ico-comments.d5ef1a92.svg";